<nav class="">
  <div class="navbar-wrapper">
    <div class="m-header">
      <a [routerLink]="['/default/']" class="b-brand">
        @if (layout === 'compact') {
        <img src="assets/images/Logo-small.svg" alt="small-menu-logo" class="logo logo-sm" />
        } @else {
        <img src="assets/images/logo.svg" alt="logo" class="logo logo-lg" />
        }
      </a>
    </div>
    <app-nav-content (NavCollapsedMob)="navCollapseMob()" (SubmenuCollapse)="navSubmenuCollapse()"
      class="scroll-div w-100 compact" />
  </div>
</nav>